import React, { useMemo } from 'react';
import { TariffViewModel } from '@common/model/billing/tariff/view';
import { compareTariffs, getTariffPerMonthPrice } from '@cp/entities/tariff';
import { parse, toSeconds } from 'iso8601-duration';
import { secondsInMonth } from 'date-fns';
import { Price } from 'src/shared/ui/price';
import { Tariff, TariffBenefit, TariffPriceSection, TariffProps, TariffTerm } from './tariff';

export interface TariffCardProps extends Pick<TariffProps, 'name' | 'sx' | 'onChange' | 'selected'> {
  tariff: TariffViewModel;
  baseTariff?: TariffViewModel;
}
export const TariffCard: React.FC<TariffCardProps> = ({ tariff, baseTariff, ...props }) => {
  const tariffsComparison = useMemo(
    () => compareTariffs([tariff, baseTariff].filter((t): t is NonNullable<typeof t> => Boolean(t))),
    [tariff, baseTariff],
  );
  const { benefit = 0, benefitPercentage = 0 } = tariffsComparison[tariff.id] ?? {};
  const monthlyPrice = getTariffPerMonthPrice(tariff);
  const months = useMemo(() => Math.round(toSeconds(parse(tariff.period || 'P1D')) / secondsInMonth), [tariff.period]);

  return (
    <Tariff value={tariff.id} {...props}>
      <TariffBenefit
        sx={{
          visibility: benefit > 0 ? 'visible' : 'hidden',
        }}
      >
        Выгода {benefitPercentage}%
      </TariffBenefit>
      <TariffTerm period={tariff.period} />
      <TariffPriceSection>
        {months > 1 ? (
          <span>
            <Price value={monthlyPrice} />
            /мес
          </span>
        ) : (
          <Price value={tariff.price} />
        )}
      </TariffPriceSection>
    </Tariff>
  );
};
